module.exports = {
  PASSWORD_EXPIRY_LIMIT: 'Password expiry limit have exceeded to days. Please update your password',
  PASSWORD_POLICY_MESSAGE:
    'Your password must be between 8 - 25 characters long having a combination of upper characters, lower characters, numbers and special characters.',
  ALL_LOCATION_ERROR: 'Select a location',
  ACH_WARNING_MSG:
    'Please note that ACH payments are PENDING until funded. This may take 2-10 business days to clear if valid.',
  FETCH_TRANSACTION_ERROR:
    'Something went wrong while trying to fetch transactions. Please contact techsupport@titaniumpayments.com or call 877-972-0700.',
  ERROR_CONTACT_SUPPORT: 'Internal server error. Please contact techsupport@titaniumpayments.com or call 877-972-0700.',
  UNKNOWN_ERROR: 'An unknown error occurred.',
  CONTACT_SUPPORT: 'Please contact techsupport@titaniumpayments.com or call 877-972-0700.',
  FAILURE_BUTTON_MESSAGE:
    'Something has gone wrong while attempting to process this transaction. Please reach out to support at techsupport@titaniumpayments.com before reattempting.',
  INQUEUE_ERROR:
    'Payment cannot be made to this invoice because it is scheduled for automatic billing at a later date.',
  SYNC_DIALOG_MESSAGE:
    'Transaction sync is currently in progress. This may take several minutes. Once the process is complete, new records will be displayed below, and you will receive an email confirmation.',
  API_KEY_USAGE_POLICY:
    'Please store this key securely and do not share it publicly. You will not be able to view this key again.',
};
